"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SortCriteriaResolver = (function () {
    function SortCriteriaResolver(fieldsHandler) {
        this.fieldsHandler = fieldsHandler;
    }
    SortCriteriaResolver.prototype.resolveFieldCriteria = function (fieldCriteria, sortDirection, enableToggle) {
        var field = fieldCriteria.charAt(0) !== "@" ? "@" + fieldCriteria : fieldCriteria;
        return this.getFieldCriteria(this.fieldsHandler.toCoveo(field), sortDirection, enableToggle);
    };
    SortCriteriaResolver.prototype.resolveDateCriteria = function (sortDirection, enableToggle) {
        return this.getFieldCriteria("date", sortDirection, enableToggle);
    };
    SortCriteriaResolver.prototype.resolveRelevancyCriteria = function () {
        return "relevancy";
    };
    SortCriteriaResolver.prototype.getFieldCriteria = function (fieldCriteria, sortDirection, enableToggle) {
        if (enableToggle) {
            return this.getFieldWithDirection(fieldCriteria, sortDirection) + ", " + this.getFieldWithDirection(fieldCriteria, this.getInvertedDirection(sortDirection));
        }
        else {
            return this.getFieldWithDirection(fieldCriteria, sortDirection);
        }
    };
    SortCriteriaResolver.prototype.getFieldWithDirection = function (fieldCriteria, sortDirection) {
        return fieldCriteria + " " + sortDirection;
    };
    SortCriteriaResolver.prototype.getInvertedDirection = function (sortDirection) {
        return sortDirection === "descending" ? "ascending" : "descending";
    };
    return SortCriteriaResolver;
}());
exports.SortCriteriaResolver = SortCriteriaResolver;



//////////////////
// WEBPACK FOOTER
// ./src/resolvers/sortCriteria/SortCriteriaResolver.ts
// module id = 45
// module chunks = 13 14